import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { LWApiPublicAccountChatPasswordGetResultRawI } from '@liquidweb-dev/club-sauce/public/account/chatPassword/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_CHATPASSWORD_GET_QUERY_KEY = '/account/chatPassword/get';

const useAccountChatPasswordGet = (
	options?: UseQueryOptions<
		LWApiPublicAccountChatPasswordGetResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ACCOUNT_CHATPASSWORD_GET_QUERY_KEY],
		queryFn: () => api.account.chatPassword.apiRaw.get(),
		...options,
	});

export default useAccountChatPasswordGet;
